enum UserRoles {
  Owner = 'owner',
  Guest = 'guest',
}

export default UserRoles;
